import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300', {
    variants: {
        variant: {
            default: 'bg-primary text-white hover:bg-primary/90',
            destructive: 'bg-red-500 text-slate-50 hover:bg-red-500/90',
            outline: 'border border-gray-200 bg-white hover:bg-gray-100 hover:text-slate-900',
            secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-100/80',
            ghost: 'hover:bg-slate-100 text-default',
            link: 'text-default underline-offset-4',
        },
        size: {
            default: 'h-10 px-4 py-2',
            sm: 'h-9 rounded-md px-3',
            lg: 'h-11 rounded-md px-8',
            icon: 'h-10 w-10',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});
const Button = React.forwardRef(({ className, variant, size, asChild = false, isLoading, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { className: cn(buttonVariants({ variant, size, className })), ref: ref, type: "button", ...props, disabled: isLoading || props.disabled, children: props.children }));
});
Button.displayName = 'Button';
const LoadingButton = ({ ...props }) => (_jsxs(Button, { ...props, children: [props.isLoading && _jsx(Loader2, { className: "animate-spin" }), " ", props.children] }));
export { Button, LoadingButton, buttonVariants };
